// @flow

import common from './locales/en/common.json'

export const en = { common }

export default en
